import { render, staticRenderFns } from "./Language.vue?vue&type=template&id=621d3a11&scoped=true"
import script from "./Language.vue?vue&type=script&lang=js"
export * from "./Language.vue?vue&type=script&lang=js"
import style0 from "./Language.vue?vue&type=style&index=0&id=621d3a11&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d3a11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621d3a11')) {
      api.createRecord('621d3a11', component.options)
    } else {
      api.reload('621d3a11', component.options)
    }
    module.hot.accept("./Language.vue?vue&type=template&id=621d3a11&scoped=true", function () {
      api.rerender('621d3a11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/Language.vue"
export default component.exports